import { useEffect, useMemo, useState } from "react";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import icons from "../../../assets/images/constantIcons";
import EditCanteen from "./EditCanteen";

const useAddCateenUsers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [editPopupIndex, setEditPopupIndex] = useState(null);
  const [canteenUsers, setCateenUsers] = useState([]);

  const handleEditPopup = (userId) => {
    setEditPopupIndex(editPopupIndex === userId ? null : userId); 
  };

  // Fetch the canteen user
  const fetchCateenUsers = async () => {
    try {
      const response = await apiService.get(`/canteen_users`);
      const usersArray = Array.isArray(response?.canteen_user) ? response.canteen_user : [response?.canteen_user];
      setCateenUsers(usersArray);
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    fetchCateenUsers();
  }, []);

  const updateCanteenUser = (updatedUser) => {
    setCateenUsers(prevUsers =>
      prevUsers.map(user =>
        user.id === updatedUser.id ? { ...user, ...updatedUser } : user
      )
    );
  };

  // Define table columns
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        headerAlign: "text-center",
        cellAlign: "text-center",
      },
      {
        Header: "Name",
        accessor: "first_name",
        headerAlign: "text-left",
        cellAlign: "text-left",
      },
      {
        Header: "Last Name",
        accessor: "last_name",
        headerAlign: "text-left",
        cellAlign: "text-left",
      },
      {
        Header: "Email",
        accessor: "email",
        headerAlign: "text-left",
        cellAlign: "text-left",
      },
      {
        Header: "Address",
        accessor: "address",
        headerAlign: "text-left",
        cellAlign: "text-left",
      },
      {
        Header: "Phone Number",
        accessor: "phone_number",
        headerAlign: "text-left",
        cellAlign: "text-left",
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center items-center gap-5">
              <button
                onClick={() => handleEditPopup(row.original.id)}
                className="p-2 flex items-center justify-center w-[40px] h-[40px] rounded-full bg-green50 text-green cursor-pointer"
              >
                <icons.FaRegEdit className="text-xl font-bold" />
              </button>
              {editPopupIndex === row.original.id && (
                <EditCanteen
                  isOpen={true}
                  onClose={() => handleEditPopup(null)}
                  userData={row.original} 
                  userId={row.original.id}
                  updateCanteenUser={updateCanteenUser}
                  fetchCateenUsers={fetchCateenUsers} 
                />
              )}
            </div>
          );
        },
      },
    ],
    [editPopupIndex] 
  );

  const data = useMemo(() => {
    return canteenUsers.map((user) => ({
      id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      address: user.address,
      email: user.email,
      phone_number: user.phone_number,
      action: "",
    }));
  }, [canteenUsers]);

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

  const handlePageChange = (newPage) => setCurrentPage(newPage);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  return {
    columns,
    currentRows,
    totalRows: data.length,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    fetchCateenUsers,
  };
};

export default useAddCateenUsers;
